module.exports = {"1902":8748,"1972":8756,"2109":8733,"2132":2548,"2139":2545,"2140":2544,"2145":2588,"2156":2527,"2184":2560,"2217":8750,"2224":2539,"2233":2530,"2266":2536,"2282":2552,"2285":2553,"2304":2538,"2338":2555,"2384":2575,"2418":2572,"2422":2555,"2483":2574,"2493":8736,"2497":2542,"2506":2541,"8601":2597,"8609":2505,"8623":2554,"8641":8735,"8708":8760,"8720":2596,"8750":8757}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json_files/stores.json
// module id = GjR7
// module chunks = 55